<script setup lang="ts">
const props = defineProps<{
  src: string
  alt?: string
}>()

const backgroundUrl = computed(() => `url('${props.src}')`)
const imageLoaded = ref(false)
const imageError = ref(false)

// Preload the image to check if it exists
onMounted(() => {
  if (props.src) {
    const img = new Image()
    img.onload = () => {
      imageLoaded.value = true
    }
    img.onerror = () => {
      imageError.value = true
      console.warn('Failed to load cover image:', props.src)
    }
    img.src = props.src
  }
})
</script>

<template>
  <div
    class="h-full w-full bg-cover bg-center"
    :class="{
      'bg-neutral-200 dark:bg-neutral-800': imageError || !imageLoaded,
    }"
    :role="alt ? 'img' : undefined"
    :aria-label="alt"
  >
    <div v-if="imageError" class="flex h-full w-full items-center justify-center">
      <UIcon name="bx:image-alt" class="size-12 text-neutral-400" />
    </div>
    <slot v-else />
  </div>
</template>

<style scoped>
div {
  background-image: v-bind(backgroundUrl);
}
</style>
